import { Pipe, PipeTransform } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'svgToMatIcon',
})
export class SvgToMatIconPipe implements PipeTransform {
    constructor(
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) {}

    transform(iconPath: string): string {
        this.iconRegistry.addSvgIcon(iconPath, this.sanitizer.bypassSecurityTrustResourceUrl(iconPath));
        return iconPath;
    }
}
